export const PARSER_API =
  'https://hm2fg6ktv4.execute-api.us-east-1.amazonaws.com/prd/svg/parser'
